import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { api } from '../../../../server/api';
import { wsActions } from '../../../ws/actions';

export function* checkTokens({ payload }) {
  try {
    yield effects.put(chatActions.startChecking());
    const response = yield effects.apply(api, api.post, [
      {
        endpoint: `chats/${payload.id}/check/`,
        body: JSON.stringify({
          additional_text: payload.additional_text,
        }),
      },
    ]);
    const result = yield effects.call([
      response,
      'json',
    ]);
    if (!response.ok) {
      yield effects.put(wsActions.setSocketError(result.error.message));
      return;
    }
    yield effects.put(chatActions.fillTokens(result));
  } catch (e) {
    yield effects.put(wsActions.setSocketError(e.message || 'Unknown error'));
  } finally {
    yield effects.put(chatActions.stopChecking());
  }
}
